var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"notice-bar"},[_c('div',{staticClass:"notice-bar__track"},[_c('span',{staticClass:"notice-bar__text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"notice-bar__text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }